import { ArrowRight, Ruler, Package2, Truck, Shield, Layers3, Warehouse } from "lucide-react";
import SEO from "@/components/SEO";
import Overline from "@/components/Overline";
import { company, seo, buildQuoteUrl } from "@/config/site";

export default function CustomPackaging() {
  const items = [
    { icon: Ruler, title: "Product", body: "Packaging worked around the product being packed." },
    { icon: Package2, title: "Dimensions", body: "Sizes tailored to the requirement." },
    { icon: Layers3, title: "Quantity", body: "Volumes discussed based on your usage." },
    { icon: Warehouse, title: "Storage", body: "Suited to warehousing and stock-keeping." },
    { icon: Truck, title: "Transportation", body: "Load handling and dispatch profile." },
    { icon: Shield, title: "Protection", body: "Moisture, static and cushioning where needed." },
  ];
  return (
    <>
      <SEO
        title="Custom Packaging"
        description="Packaging built around your product, dimensions, quantity, storage and transportation requirements."
        canonical={`${seo.siteUrl}/custom-packaging`}
      />
      <section className="border-b border-neutral-200 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-24">
          <Overline>Custom Packaging</Overline>
          <h1 className="font-heading mt-4 text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight text-neutral-900">Packaging built around your requirement.</h1>
          <p className="mt-6 max-w-3xl text-neutral-600 leading-relaxed">
            Packaging requirements may vary by product, dimensions, quantity, handling, storage, transportation and protection. Discuss your requirements with {company.fullCompanyName} and we can identify a suitable packaging product.
          </p>
          <div className="mt-8">
            <a href={buildQuoteUrl()} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 bg-[#A91D22] text-white px-6 py-3 text-sm font-medium hover:bg-[#8B181C] rounded-sm" data-testid="custom-request-quote">
              Request a Quote <ArrowRight size={16} />
            </a>
          </div>
        </div>
      </section>

      <section className="py-16 md:py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {items.map((f) => (
            <div key={f.title} className="bg-white border border-neutral-200 p-6 rounded-sm">
              <f.icon className="text-[#A91D22]" aria-hidden="true" />
              <div className="mt-4 font-heading text-xl font-semibold text-neutral-900">{f.title}</div>
              <p className="mt-2 text-sm text-neutral-600 leading-relaxed">{f.body}</p>
            </div>
          ))}
        </div>
      </section>
    </>
  );
}
